<template>
  <Card class="card-counter pos-relative" :style="styles">
    <div class="count" v-if="showCounter"> {{count}}</div>
    <div class="text-wrap">
      <p v-if="subText"><small>{{ subText }}</small></p>
      <h3 class="text">{{ text }}</h3>
    </div>
    <Icon v-if="icon" class="feat-icon" :type="icon" />
    <img v-else :src="require(`../../assets/${imgSrc}`)" alt="kromnix logo" width="55" class="v-centered" style="right:20px">
  </Card>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: 'Test',
      required: true
    },
    subText: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    imgSrc: {
      type: String,
      default: null
    },
    styles: {
      type: String,
      default: 'background:#595959;color:#ffffff;'
    },
    showCounter: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-counter {
  min-height: 110px;
  height: 100%;
  .count {
    font-size: 31px;
    font-weight: bold;
  }
  .feat-icon {
    position: absolute;
    top: 25px;
    right: 25px;
    font-size: 50px;
    color: rgba(0, 0, 0, 0.15);
  }
  .text-wrap {
    position: absolute;
    bottom: 15px;
  }
}
</style>
